<div class="content-container">
	<h2 *ngIf="title">{{ title }}</h2>
	<hr *ngIf="title" />
	<ng-content></ng-content>
</div>
